import React from "react";
import {Icon} from "../Icon/Icon";
export const ErrorIcon = () => {
    return (

        <Icon value={'error'} colorClass={'danger-200-svg error-icon'} />

    );
};